import type { StaticImageData } from 'next/image'
import { ChainId } from 'helpers/enums'
import betswirlImage from '../images/betswirl.png'
import bookieBotImage from '../images/bookiebot.png'

import bookmakerxyzImage from '../images/bookmakerxyz.png'
import yezbetImage from '../images/yezbet.png'
import boxBetImage from '../images/boxbet.png'
import dexwinImage from '../images/dexwin.png'
import gambleFkkersImage from '../images/gamblefkkers.svg?url'
import gamblinoImage from '../images/gamblino.svg?url'
import gamblrImage from '../images/gamblr.svg?url'
import juicyBetImage from '../images/juicybet.png'
import maskNetworkImage from '../images/mask-network.png'
import meritCircleImage from '../images/merit-circle.png'
import normiesImage from '../images/normies.jpg'
import xyzBetImage from '../images/xyzbet.svg?url'
import wagerBotImage from '../images/wagerbot.png'
import metavaultImage from '../images/metavault.png'
import purebetImage from '../images/purebet.png'
// import sendPicksImage from '../images/sendpicks.png'
import ridottoImage from '../images/ridotto.svg?url'
import bitRubyImage from '../images/bitruby.png'
import dgBetImage from '../images/dgbet.png'
import onChainBetsImage from '../images/onchainbets.png'
import giraftImage from '../images/giraft.svg?url'
import pinwinImage from '../images/pinwinxyz.png'


export enum Tag {
  PredictionApp,
  TelegramBot,
  DApp,
  Custodial,
}

export type Project = {
  image: StaticImageData;
  name: string;
  description: string;
  tags: Tag[];
  link: string | undefined;
  bgColor?: string;
  chains: (ChainId | 'Solana')[] | undefined;
  hasGeoBlock: boolean;
};

const projects = [
  {
    image: bookmakerxyzImage,
    name: 'bookmaker.XYZ',
    description:
      'The ultimate showcase of pure on-chain betting. No logins, no bans, no limits. bookmaker.XYZ is 100% powered by Azuro’s open, permissionless markets and games.',
    tags: [ Tag.PredictionApp ],
    link: 'https://bookmaker.xyz?utm_source=azuro&utm_medium=azuro&utm_campaign=ecosystem_page',
    chains: [ ChainId.Gnosis, ChainId.Polygon, ChainId.Base ],
    hasGeoBlock: true,
  },
  {
    image: yezbetImage,
    name: 'YezBet',
    description:
      'All-in-one next-gen Web3 decentralised crypto betting platform.',
    tags: [ Tag.PredictionApp ],
    link: 'https://yez.bet/sports?utm_source=azuro&utm_medium=azuro&utm_campaign=ecosystem_page',
    chains: [ ChainId.Polygon ],
    hasGeoBlock: true,
  },
  {
    image: dexwinImage,
    name: 'DexWin',
    description:
      'Best odds, instant bonuses and sexiest UI/UX in web 3.0 betting. Bet directly from your wallet or enjoy Gasless betting from your decentralized DexWin wallet.',
    tags: [ Tag.PredictionApp ],
    link: 'https://sportsbook.dexwin.bet/?referralID=azuro&utm_source=azuro&utm_medium=azuro&utm_campaign=ecosystem_page',
    chains: [ ChainId.Polygon, ChainId.Base ],
    hasGeoBlock: true,
  },
  {
    image: dgBetImage,
    name: 'DGBet',
    description:
      'DGbet is the go-to GambleFi product 4 Sports Fans & DeGens. With 70% cashback on your monthly losses, we offer a fully on-chain and non-custodial product.',
    tags: [ Tag.PredictionApp ],
    link: 'https://t.co/ORiCUFnGhE',
    chains: [ ChainId.Gnosis, ChainId.Polygon, ChainId.Base ],
    hasGeoBlock: true,
  },
  {
    image: betswirlImage,
    name: 'BetSwirl',
    description:
      'Transforming the future of GambleFi within Web3. Bringing excitement and transparency to Gambling.',
    tags: [ Tag.PredictionApp ],
    link: 'https://app.betswirl.com/sports?utm_source=azuro&utm_medium=azuro&utm_campaign=ecosystem_page',
    chains: [ ChainId.Polygon, ChainId.Gnosis ],
    hasGeoBlock: false,
  },
  {
    image: giraftImage,
    name: 'Giraft',
    description:
      'Smooth on-chain betting experience, combining best-in-class odds, zero friction, and a sleek interface. Giraft sets a new standard for Web3 sports betting.',
    tags: [ Tag.PredictionApp ],
    link: 'https://giraft.io/?utm_source=azuro&utm_medium=azuro&utm_campaign=ecosystem_page',
    bgColor: 'hsl(81,99%,59%)',
    chains: [ ChainId.Gnosis, ChainId.Polygon, ChainId.Base ],
    hasGeoBlock: true,
  },
  {
    image: gambleFkkersImage,
    name: 'GambleF*kkers',
    description:
      'The only place in the world where everyone gets 35% cashback on their betting losses.',
    tags: [ Tag.PredictionApp ],
    link: 'https://gamblefukkers.xyz/?utm_source=azuro&utm_medium=azuro&utm_campaign=ecosystem_page',
    chains: [ ChainId.Polygon ],
    hasGeoBlock: true,
  },
  {
    image: gamblrImage,
    name: 'Gamblr.xyz',
    description:
      'A non-custodial gambling application where you control your money at every step of the way.',
    tags: [ Tag.PredictionApp ],
    link: 'https://www.gamblr.xyz?utm_source=azuro&utm_medium=azuro&utm_campaign=ecosystem_page',
    bgColor: '#000',
    chains: [ ChainId.Polygon, ChainId.Gnosis ],
    hasGeoBlock: true,
  },
  {
    image: juicyBetImage,
    name: 'JuicyBet',
    description:
      'Unpeel the fun with Juicy Bet! 🍓 Because life\'s a gamble, but your rewards shouldn’t be. Decentralized betting with a splash of fruitiness.',
    tags: [ Tag.PredictionApp ],
    link: 'https://juicybet.net?utm_source=azuro&utm_medium=azuro&utm_campaign=ecosystem_page',
    chains: [ ChainId.Polygon ],
    hasGeoBlock: true,
  },
  {
    image: bookieBotImage,
    name: 'BookieBot',
    description: 'Sports betting integrated directly into Telegram.',
    tags: [ Tag.Custodial, Tag.TelegramBot ],
    link: 'https://t.me/BookieBot_tgbot ',
    chains: [ ChainId.Polygon ],
    hasGeoBlock: false,
  },
  // {
  //   image: boxBetImage,
  //   name: 'BoxBet',
  //   description: 'Turbocharged Sports Betting on Telegram. Start betting in less than 60 seconds.',
  //   tags: [ Tag.Custodial, Tag.TelegramBot ],
  //   link: 'https://boxbet.app',
  //   bgColor: '#000',
  //   chains: [ ChainId.Polygon ],
  //   hasGeoBlock: true,
  // },
  {
    image: purebetImage,
    name: 'PureBet',
    description:
      'The only onchain sports betting aggregator making sure you get the best odds and deepest liquidity on every bet you place.',
    tags: [ Tag.Custodial, Tag.PredictionApp ],
    link: 'https://exchange.purebet.io/?utm_source=azuro&utm_medium=azuro&utm_campaign=ecosystem_page',
    bgColor: '#000',
    chains: [ 'Solana' ],
    hasGeoBlock: false,
  },
  {
    image: gamblinoImage,
    name: 'Gamblino',
    description:
      'Gamblino is a decentralized GambleFi protocol covering Sportsbook, Poker and classic games of chance.',
    tags: [ Tag.PredictionApp ],
    link: 'https://gamblino.app?utm_source=azuro&utm_medium=azuro&utm_campaign=ecosystem_page',
    chains: [ ChainId.Polygon ],
    hasGeoBlock: false,
  },
  // {
  //   image: metavaultImage,
  //   name: 'Metavault',
  //   description: 'Your Gateway to cross-chain DeFi. On Metavault, users can trade Perps & on Spot, seize multi-reward opportunities, and experience a next-level user experience.',
  //   tags: [ Tag.PredictionApp ],
  //   link: 'https://metavault.trade/apps/sportsbook',
  //   chains: [ ChainId.Polygon ],
  //   hasGeoBlock: true,
  // },
  // {
  //   image: xyzBetImage,
  //   name: 'XYZBET',
  //   description: 'Web3 betting platform on Telegram. No KYC. Non-custodial. Instant payouts.',
  //   tags: [ Tag.Custodial, Tag.TelegramBot ],
  //   link: 'https://t.me/xyzbet_tgbot',
  //   chains: [ ChainId.Polygon ],
  //   hasGeoBlock: true,
  // },
  {
    image: ridottoImage,
    name: 'Ridotto',
    description:
      'The ultimate destination for casino gaming and sports betting. Decentralised, thrilling gameplay, fair odds, and lucrative rewards all in one platform. Play, bet, and win with Ridotto!',
    tags: [ Tag.PredictionApp ],
    link: 'https://ridotto.io/sports/?utm_source=azuro&utm_medium=azuro&utm_campaign=ecosystem_page',
    chains: [ ChainId.Polygon ],
    bgColor: '#064fdc',
    hasGeoBlock: false,
  },
  // {
  //   image: sendPicksImage,
  //   name: 'Sendpicks',
  //   description: 'Decentralized sportsbook meets the thrill of daily fantasy sports, powered by the innovation of web3. With all bets fully on-chain using Chainlink Oracles and
  // automation, they offer same-day automated payouts.', tags: [ Tag.PredictionApp ], link: 'https://app.sendpicks.io/', chains: [ ChainId.Polygon ], bgColor: '#0E131A', },
  {
    image: normiesImage,
    name: 'Normies',
    description:
      'By using easy-to-understand technology, Normies is creating new utilities for members to share resources and make decisions that improve their living spaces.',
    tags: [ Tag.PredictionApp ],
    link: 'https://normies.online?utm_source=azuro&utm_medium=azuro&utm_campaign=ecosystem_page',
    chains: [ ChainId.Polygon ],
    hasGeoBlock: false,
  },
  {
    image: wagerBotImage,
    name: 'Wager Bot',
    description:
      'Navigating the predictions right within your telegram app. Join us on our journey to transform the predictions landscape with cutting-edge telegram bot solutions to participate across various platforms.',
    tags: [ Tag.Custodial, Tag.TelegramBot ],
    link: 'https://t.me/WagerBettingBot',
    chains: [ ChainId.Polygon ],
    hasGeoBlock: false,
  },
  {
    image: onChainBetsImage,
    name: 'OnChainBets',
    description:
      'Place bets directly on chain and earn 🍒 OnChain tokens 🍍 Azuro Score and 🍎 Freebets; No Registration No Deposit and No Withdraw Limits',
    tags: [ Tag.PredictionApp ],
    link: 'https://onchainbets.xyz/?utm_source=azuro&utm_medium=azuro&utm_campaign=ecosystem_page',
    chains: [ ChainId.Polygon ],
    hasGeoBlock: false,
  },
  {
    image: bitRubyImage,
    name: 'BitRuby',
    description:
      'BitRuby is a cryptocurrency-based iGaming platform. It features sports betting, web3 provably fair games, a dynamic bonus system and exciting tournaments.',
    tags: [ Tag.PredictionApp ],
    link: 'https://sport.bitruby.io/?utm_source=azuro&utm_medium=azuro&utm_campaign=ecosystem_page',
    chains: [ ChainId.Polygon, ChainId.Gnosis ],
    hasGeoBlock: false,
  },
  // {
  //   image: meritCircleImage,
  //   name: 'Merit Circle',
  //   description: 'A decentralized autonomous organization on a mission to revolutionize gaming. Let\'s build the metaverse by empowering people to be a part of it.',
  //   tags: [ Tag.DApp ],
  //   link: undefined,
  //   chains: undefined,
  //   hasGeoBlock: true,
  // },
  // {
  //   image: maskNetworkImage,
  //   name: 'Mask Network',
  //   description: 'Mask Network brings privacy and benefits from Web3 to social media like Facebook & Twitter - with an open-source browser extension.',
  //   tags: [ Tag.DApp ],
  //   link: undefined,
  //   chains: undefined,
  //   hasGeoBlock: true,
  // },
  {
    image: pinwinImage,
    name: 'PinWin.xyz',
    description:
      'The coolest onchain sports betting experience bringing Azuro liquidity to Solana. Social logins, unique stats and insights, gasless betting, and copy trading. Available on Solana, Polygon, Base, Gnosis.',
    tags: [ Tag.PredictionApp ],
    link: 'https://pinwin.xyz/?utm_source=azuro&utm_medium=azuro&utm_campaign=ecosystem_page',
    chains: [ 'Solana', ChainId.Gnosis, ChainId.Polygon, ChainId.Base ],
    hasGeoBlock: true,
  },
] as const satisfies Project[]

export type ProjectName = Pick<(typeof projects)[number], 'name'>['name'];

const order: ProjectName[] = [
  'bookmaker.XYZ',
  'DexWin',
  'DGBet',
  'Giraft',
  'GambleF*kkers',
  'Gamblr.xyz',
  'PinWin.xyz',
  'JuicyBet',
  'BookieBot',
  // 'BoxBet',
  'BetSwirl',
  // 'ChainWager',
  'PureBet',
  'Gamblino',
  // 'CoWager',
  // 'Metavault',
  // 'PEPEbet.ai Polygon',
  // 'XYZBET',
  // 'Cochilli',
  'Ridotto',
  // 'gib.casino',
  // 'Sendpicks',
  // 'Yez.bet',
  'Normies',
  'OnChainBets',
  'BitRuby',
  'Wager Bot',
  'YezBet',
  // 'Merit Circle',
  // 'Mask Network',
]

projects.sort((a, b) => {
  const aIndex = order.indexOf(a.name)
  const bIndex = order.indexOf(b.name)

  if (aIndex < 0 || bIndex < 0) {
    return 0
  }

  return aIndex - bIndex
})

export default projects
